import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import Login from './views/Login/Login'
// import LoginHome from './views/Login/Home'
// import StudentLogin from './views/Login/StudentLogin'
// import TeacherLogin from './views/Login/TeacherLogin'
import Form from './views/Login/Form'
import ForgetPassword from './views/Login/ForgetPassword'
// import SendEmail from './views/Login/SendEmail'
import ResetPassword from './views/Login/ResetPassword'
import privacyPolicy from './views/Login/privacyPolicy'

// import Home from './views/Student/Home'
import Root from './views/Root'
// import Student from './views/Student/Student'
// import Teacher from './views/Teacher/Teacher'
import Home from './views/Home'
// import HomeWeekly from './components/Teacher/Home/WeeklySchedule'
// import HomeDaily from './components/Teacher/Home/DailySchedule'
// import HomeMonthly from './components/Teacher/Home/MonthlySchedule'

import Resources from './views/Resources/Resources'

import AllResources from './views/Resources/AllResources'
import MyResources from './views/Resources/MyResources'
import BookmarkResources from './views/Resources/BookmarkResources'

// import TeacherMyClassSetting from './components/Teacher/MyClass/Setting'
// import TeacherMyClassMissionSetting from './components/Teacher/MyClass/MissionSetting'
// import TeacherMyClassMarking from './components/Teacher/MyClass/Marking'
// import TeacherMyClassStudent from './components/Teacher/MyClass/Student'
// import TeacherMyClassStudentStatus from './components/Teacher/MyClass/StudentStatus'
// import TeacherMyClassForum from './components/Teacher/MyClass/Forum'
// import TeacherMyClassAnnouncement from './views/Teacher/Class/Announcement'
import Class from './views/Class/Class'
import ClassHome from './views/Class/Home'
// import ClassInfo from './views/Class/Info'
import ClassWeeks from './views/Class/Weeks'
import ClassActivities from './views/Class/Activities'
import ClassActivity from './views/Class/Activity'
import ClassAnnouncement from './views/Class/Announcement'

import ClassGradebook from './views/Class/Gradebook'
import ClassReport from './views/Class/Report'
import ClassReportDetail from './views/Class/ReportDetail'
import ClassMember from './views/Class/Member'
import ClassProgress from './views/Class/Progress'
// import HomeWeekly from './components/Home/WeeklySchedule'
// import HomeDaily from './components/Home/DailySchedule'
// import HomeMonthly from './components/Home/MonthlySchedule'

import Video from './views/Video'
import Profile from './views/Profile'
// import MailBox from './views/Student/MailBox'
// import Schedule from './views/Student/Schedule'
// import Ranking from './views/Student/Ranking'
// import VideoPool from './views/Student/VideoPool'
// import BookmarkedVideos from './views/Student/BookmarkedVideos'

import ComingSoon from './views/ComingSoon'
import ErrorPage from './views/Error'
// import StudentMyClass from './views/Student/MyClass'
// import StudentMyClassHome from './views/Student/Class/Home'
// import StudentMyClassWeeks from './views/Student/Class/Weeks'
// import StudentMyClassActivities from './views/Student/Class/Activities'
// import StudentMyClassActivity from './views/Student/Class/Activity'
// import TeacherMyClassAnnouncement from './views/Teacher/Class/Announcement'
// import StudentMyClassInfo from './views/Student/Class/Info'

// import StudentMyClassAnnouncement from './components/Teacher/MyClass/Announcements/Announcement'
import CourseInfo from './components/CourseInfo/CourseInfo'

import $ from 'jquery'
Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: '/ui',
  routes: [
    // {
    //   path: '',
    //   name: 'Root'
    // },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      children: [
        // {
        //   path: '',
        //   alias: 'home',
        //   name: 'LoginHome',
        //   component: LoginHome
        // },
        // {
        //   path: 'student',
        //   name: 'StudentLogin',
        //   component: StudentLogin
        // },
        // {
        //   path: 'teacher',
        //   name: 'TeacherLogin',
        //   component: TeacherLogin
        // },
        {
          path: '',
          alias: 'form',
          name: 'Form',
          component: Form
        },
        {
          path: 'forget-password',
          name: 'ForgetPassword',
          component: ForgetPassword
        },
        {
          path: 'reset-password',
          name: 'ResetPassword',
          component: ResetPassword
        }
      ],
      meta: { requiresAuth: false }
    },
    {
      path: '',
      name: 'Root',
      component: Root,
      children: [
        {
          path: '',
          alias: 'home',
          name: 'Home',
          component: Home
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile
        },
        // {
        //   path: 'mailbox',
        //   name: 'MailBox',
        //   component: MailBox
        // },
        // {
        //   path: 'schedule',
        //   name: 'Schedule',
        //   component: Schedule
        // },
        // {
        //   path: 'learning',
        //   name: 'VideoPool',
        //   component: VideoPool
        // },
        // {
        //   path: 'bookmarked',
        //   name: 'BookmarkedVideos',
        //   component: BookmarkedVideos
        // },
        // {
        //   path: 'ranking',
        //   name: 'Ranking',
        //   component: Ranking
        // },
        {
          path: 'classes',
          name: 'Class',
          component: Class,
          children: [
            {
              path: '',
              name: 'ClassHome',
              component: ClassHome
            },
            // {
            //   path: 'courseinfo',
            //   name: 'CourseInfo',
            //   component: CourseInfo
            // },
            {
              path: 'weeks',
              name: 'ClassWeeks',
              component: ClassWeeks
            },
            {
              path: 'weeks/activities',
              name: 'ClassActivities',
              component: ClassActivities
            },
            {
              path: 'weeks/activity',
              name: 'ClassActivity',
              component: ClassActivity
            },
            {
              path: 'info',
              name: 'ClassInfo',
              component: CourseInfo
            },
            {
              path: 'announcement',
              name: 'ClassAnnouncement',
              component: ClassAnnouncement
            },
            {
              path: 'report',
              name: 'ClassReport',
              component: ClassReport
            },
            {
              path: 'report/detail',
              name: 'ClassReportDetail',
              component: ClassReportDetail
            },
            {
              path: 'gradebook',
              name: 'ClassGradebook',
              component: ClassGradebook
            },
            {
              path: 'member',
              name: 'ClassMember',
              component: ClassMember
            },
            {
              path: 'progress',
              name: 'ClassProgress',
              component: ClassProgress
            }
          ]
        },
        {
          path: 'resources',
          name: 'Resources',
          component: Resources,
          children: [
            {
              path: '',
              name: 'AllResources',
              component: AllResources
            },
            {
              path: 'self',
              name: 'MyResources',
              component: MyResources
            },
            {
              path: 'bookmarked',
              name: 'BookmarkResources',
              component: BookmarkResources
            },
            {
              path: 'video',
              name: 'Video',
              component: Video
            }
          ]
        },
        {
          path: 'coming-soon',
          name: 'ComingSoon',
          component: ComingSoon
        }
      ],
      meta: { requiresAuth: true }
    },
    {
      path: '/privacy-policy',
      name: 'privacyPolicy',
      component: privacyPolicy
    },
    // {
    //   path: '/teacher',
    //   name: 'Teacher',
    //   component: Teacher,
    //   children: [
    //     {
    //       alias: '',
    //       path: 'home',
    //       component: Home,
    //       children: [
    //         {
    //           alias: '',
    //           path: 'weekly',
    //           name: 'HomeWeekly'
    //           // component: HomeWeekly
    //         },
    //         {
    //           path: 'daily',
    //           name: 'HomeDaily'
    //           // component: HomeDaily
    //         },
    //         {
    //           path: 'monthly',
    //           name: 'HomeMonthly'
    //           // component: HomeMonthly
    //         }
    //       ]
    //     },
    //     {
    //       path: 'classes',
    //       name: 'Class',
    //       component: Class,
    //       children: [
    //       //   {
    //       //     path: 'announcement',
    //       //     name: 'Announcement',
    //       //     component: Announcement
    //       //   },
    //         {
    //           alias: '',
    //           path: 'home',
    //           name: 'ClassHome',
    //           component: ClassHome
    //         },
    //         {
    //           path: 'weeks',
    //           name: 'ClassWeeks',
    //           component: ClassWeeks
    //         },
    //         {
    //           path: 'weeks/activities',
    //           name: 'ClassActivities',
    //           component: ClassActivities
    //         },
    //         {
    //           path: 'weeks/activity',
    //           name: 'ClassActivity',
    //           component: ClassActivity
    //         },
    //         {
    //           path: 'announcement',
    //           name: 'TeacherMyClassAnnouncement'
    //           // component: TeacherMyClassAnnouncement
    //         },
    //         {
    //           path: 'info',
    //           name: 'ClassInfo',
    //           component: ClassInfo
    //         },
    //         {
    //           path: 'record',
    //           name: 'TeacherMyClassReport',
    //           component: TeacherMyClassReport
    //         },
    //         {
    //           path: 'gradebook',
    //           name: 'TeacherMyClassGradebook',
    //           component: TeacherMyClassGradebook
    //         }
    //       ]
    //     },
    //     {
    //       path: 'resources',
    //       name: 'TeacherResources',
    //       component: TeacherResources
    //     },
    //     {
    //       path: 'my-resources',
    //       name: 'TeacherMyResources',
    //       component: TeacherMyResources
    //     },
    //     {
    //       path: 'teacher/*',
    //       redirect: '/teacher'
    //     }
    //   ],
    //   meta: { requiresAuth: true }
    // },
    {
      path: '*',
      component: ErrorPage
    }
  ],
  scrollBehavior (to, form, savedPosition) {
    if (to === form && savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {
  if ($('body').hasClass('modal-open')) {
    if (confirm('確定關閉')) {
      $('form').trigger('reset')
      $('#member_list').css({ display: 'none' })
      $('body').removeClass('modal-open')
      $('div.modal-backdrop').remove()
    } else {
      next(false)
      return
    }
  }

  console.log('beforeEach')
  console.log(`I come from ${from.path} to ${from.path}`)
  console.log(`I come from ${from.name} to ${to.name}`)
  console.log('to route')
  console.log(to)
  console.log('from route')
  console.log(from)
  console.log('to.matched')
  console.log(to.matched.some(route => route.meta.requiresAuth))
  console.log(store.getters.isLoggedIn)
  if (to.matched.some(route => route.meta.requiresAuth)) {
    store.dispatch('getProfile').then(user => {
      //  if cookie is vailid, update local variable and continue
      store.commit('setUser', user)
      next()
    }).catch(() => {
      //  else rediect user to login page
      next('/login')
    })
  } else {
    store.dispatch('getProfile').then(user => {
      //  if cookie is vailid, update local variable and continue
      store.commit('setUser', user)
      next('/')
    }).catch(() => {
      //  else rediect user to login page
      next()
    })
  }
  // if (to.matched.some(route => route.meta.requiresAuth)) {
  //   //  if the user want to go to logined page, we need to check auth
  //   if (!store.getters.isLoggedIn) {
  //     //  if there is no local variable, there may be valid cookie session
  //     store.dispatch('getProfile').then(user => {
  //       //  if cookie is vailid, update local variable and continue
  //       store.commit('setUser', user)
  //       next()
  //     }).catch(() => {
  //       //  else rediect user to login page
  //       next('/login')
  //     })
  //   } else {
  //     next()
  //   }
  // } else {
  //   if (store.getters.isLoggedIn) {
  //     next('/')
  //   } else {
  //     next()
  //   }
  // }
})
export default router
